import React from "react";
import { Spinner as DeprecatedSpinner } from "@chakra-ui/react";

import { useRequestInProgress } from "lib/api";
import { colours } from "@shared/ui.design-system";

type Props = {
  size?: string;
  thickness?: string;
};

export const LoadingMask: React.FC<Props> = ({
  size = "xl",
  thickness = "4px"
}) => {
  const requestInProgress = useRequestInProgress();

  return requestInProgress ? (
    <div
      data-testid="loading-mask"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 2
      }}
    >
      <span
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: colours.secondary.light,
          opacity: 0.75
        }}
      />
      <DeprecatedSpinner
        color={colours.accent.strong}
        size={size}
        thickness={thickness}
      />
    </div>
  ) : null;
};
